import { ModalBody } from './ModalBody'
import { ModalContainer } from './ModalContainer'
import { ModalHeader } from './ModalHeader'

export const Modal = {
  root: ModalContainer,
  header: ModalHeader,
  body: ModalBody,
}
